<!-- @format -->

<ng-template #modalContent>
	@if (mediaItems.length > 0) {
		<div class="hmf-display-flex hmf-flex-column hmf-flex-m-row hmf-px-s hmf-mt-s">
			<div class="hmf-w-100 hmf-mr-s hmf-position-relative">
				<button
					class="reviews-social-previous-btn hmf-round-radius hmf-align-items-center hmf-justify-content-center"
					[ngClass]="{
						'hmf-display-none': mediaIndex <= 0,
						'hmf-display-flex': mediaIndex > 0
					}"
					aria-label="Scroll left"
					[disabled]="sliderPositon === 0"
					(click)="previousSlide()">
					<homefield-icon
						name="chevron-left"
						fill="var(--hmf-label-secondary-static)"></homefield-icon>
				</button>
				<product-reviews-review-media
					[media]="mediaItems[mediaIndex]"
					[objectFit]="ObjectFitEnum.CONTAIN"
					[mediaSource]="MediaSourceEnum.SECTION"
					(selectedMedia)="selectedMediaClick()"></product-reviews-review-media>
				<div
					class="hmf-display-flex review-social-likes-container label-secondary-subtle-static fill-base hmf-xxxs hmf-px-xxxs">
					<homefield-icon
						name="reaction-love-outlined"
						class="hmf-mr-xxxs hmf-mb-xxxs"
						width="14"
						height="14"
						fill="var(--hmf-label-secondary-subtle-static)"></homefield-icon>
					@if (mediaItems[mediaIndex].likeCount) {
						<span>{{ mediaItems[mediaIndex].likeCount }}</span>
					}
				</div>
				<button
					class="reviews-social-next-btn hmf-round-radius hmf-align-items-center hmf-justify-content-center"
					[ngClass]="{
						'hmf-display-none': mediaIndex >= mediaItems.length - 1,
						'hmf-display-flex': mediaIndex < mediaItems.length - 1
					}"
					aria-label="Scroll right"
					(click)="nextSlide()">
					<homefield-icon
						name="chevron-right"
						fill="var(--hmf-label-secondary-static)"></homefield-icon>
				</button>
			</div>
			<div class="hmf-w-100 hmf-mt-s hmf-mt-m-0 review-products-displayed-container">
				<span class="hmf-display-flex hmf-align-items-center hmf-mb-xxs">
					<span class="hmf-header-bold-m hmf-mr-xxs">In This Look</span>
					<span class="hmf-header-s label-base-subtle"
						>({{ mediaItems[mediaIndex].products.length }})</span
					>
				</span>
				<div class="scrollable-container hmf-overflow-y-auto hmf-overflow-x-hidden">
					@for (product of mediaItems[mediaIndex].products; track product.id) {
						<hmf-product-card
							[variant]="'horizontal'"
							[productData]="product"
							[buttonStyle]="'secondary'"
							[showLinkToProduct]="!product?.price?.display"
							(viewProductClick)="goToProduct(product)"></hmf-product-card>
					}
				</div>
			</div>
		</div>
	}
</ng-template>
